module.exports = __webpack_public_path__ + "static/media/testenviosMasivos.922fdfbc.csv";